import { route } from "../../service/routeDictionary";
import API from "../../service/api";
import { environment } from "../../environments/env";

const state = {
  dashboard: [],
  store: [],
  filter: {
    type: "",
    date: {
      start: "",
      end: "",
    },
  },
};

const getters = {
  getSelectedStores: (state) => state.store,
  getFilterTypes: (state) => state.filter,
};

const actions = {
  async getdash({ commit }, data) {
    const timeElapsed = Date.now();
    const today = new Date(timeElapsed);

    const currentDate = new Date();
    const sevenDays = new Date(currentDate.setDate(currentDate.getDate() - 7));
    if (data.isByName) {
      return await API.post(
        `${environment.apiUri}${
          route.GetAllOrFilteredInstagrams
        }?data_inicio=${sevenDays.toISOString()}&data_fim=${today.toISOString()}`,
        data.stores
      );
    }
    if (data.isTime) {
      return await API.post(
        `${environment.apiUri}${route.GetAllOrFilteredInstagrams}?data_inicio=${data.comeco}&data_fim=${data.end}`,
        data.stores
      );
    }
    if (data.start) {
      return await API.post(
        `${environment.apiUri}${
          route.GetAllOrFilteredInstagrams
        }?data_inicio=${sevenDays.toISOString()}&data_fim=${today.toISOString()}`
      );
    }
  },
  async getcommets({ commit }, data) {
    if (data.isByName) {
      return await API.get(
        `${environment.apiUri}${route.InstagramComments}?instaPageId=${data.stores}&limit=6&sort=-timestamp`
      );
    }
    if (data.isTime) {
      return await API.get(
        `${environment.apiUri}${route.InstagramComments}?data_inicio=${data.comeco}&data_fim=${data.end}&instaPageId=${data.stores}`
      );
    }
    if (data.start) {
      return await API.get(
        `${environment.apiUri}${route.InstagramComments}?limit=6&Sort=-timestamp`
      );
    }
  },
  async getmedia({ commit }, data) {
    if (data.isByName) {
      return await API.get(
        `${environment.apiUri}${route.InstagramMedia}?instaPageId=${data.stores}&limit=6&sort=-timestamp`
      );
    }
    if (data.isTime) {
      return await API.get(
        `${environment.apiUri}${route.InstagramMedia}?data_inicio=${data.comeco}&data_fim=${data.end}&instaPageId=${data.stores}`
      );
    }
    if (data.start) {
      return await API.get(
        `${environment.apiUri}${route.InstagramMedia}?limit=6&sort=-timestamp`
      );
    }
  },
  async setFilterType({ commit }, filterType) {
    commit("SET_SELECTED_FILTER_TYPE", filterType);
  },

  async getstory({ commit }, data) {
    const timeElapsed = Date.now();
    const today = new Date(timeElapsed);

    const currentDate = new Date();
    const yesterday = new Date(currentDate.setDate(currentDate.getDate() - 2));
    if (data.start) {
      return await API.get(`${environment.apiUri}${route.InstagramMedia}`);
    }
    if (data.isTime) {
      return await API.get(
        `${environment.apiUri}${route.InstagramMedia}?data_inicio=${data.comeco}&data_fim=${data.end}&instaPageId=${data.stores}`
      );
    }
    if (data.isByName) {
      return await API.get(
        `${environment.apiUri}${route.InstagramMedia}?instaPageId=${
          data.stores
        }&data_inicio=${yesterday.toISOString()}&data_fim=${today.toISOString()}`
      );
    }
  },
};
const mutations = {
  SET_DASH(state, dashboard) {
    state.dashboard = dashboard;
  },
  SET_STORES(state, store) {
    state.store = store;
  },
  SET_SELECTED_FILTER_TYPE(state, filter) {
    state.filter = filter;
  },
};

export default {
  state,
  actions,
  getters,
  mutations,
};
